// Returns a unique filename, adding a counter if it was already used
export function deduplicateFilename(
  filename: string,
  filenameUsageCount: Map<string, number>,
): string {
  const count = (filenameUsageCount.get(filename) ?? 0) + 1;
  filenameUsageCount.set(filename, count);
  return getZipEntryName(filename, count);
}

// Adds "_<count>" before the extension if the counter > 1
function getZipEntryName(baseName: string, usageCount: number): string {
  if (usageCount <= 1) return baseName;
  const dot = baseName.lastIndexOf(".");
  if (dot >= 0) {
    return `${baseName.slice(0, dot)}_${usageCount}${baseName.slice(dot)}`;
  }
  return `${baseName}_${usageCount}`;
}
